var VersionsViewController = function ($scope, $http) {
    var versionsData = [];

    var versions = {
        "Login-ui": {
            name: "Login-ui",
            path: "/participant/versions.json",
            href: "/participant/#/dependencies"
        },
        "Enrollment-ui": {
            name: "Enrollment-ui",
            path: "/participant/enroll/versions.json",
            href: "/participant/enroll/#/dependencies"
        },
        "Participant-ui": {
            name: "Participant-ui",
            path: "/participant/accounts/versions.json",
            href: "/participant/accounts/#/dependencies"
        },
        "Liat-ui": {
            name: "Liat-ui",
            path: "/participant/home/versions.json",
            href: "/participant/home/#/dependencies"
        },
        "Customization-ui": {
            name: "Customization-ui",
            path: "/ui/customization-ui/versions.json",
            href: "/ui/customization-ui/versions.json"
        }
    };

    var cacheBust = new Date().getTime();

    angular.forEach(versions, function (o) {
        $http.get(o.path + "?cb=" + cacheBust).then(
            function (response) {
                var data = response.data;
                var versionInfo = {};

                versionInfo.name = o.name;
                versionInfo.url = o.href;
                versionInfo.version = data.version;
                versionInfo.dataAvailable = true;
                versionsData.push(versionInfo);
            },
            function errorCallback(response) {
                var versionInfo = {};
                versionInfo.name = o.name;
                versionInfo.dataAvailable = false;
                versionsData.push(versionInfo);

                console.log("Error retrieving versions: " + o.path + "    " + response.data);
            }
        );
    });

    //Sort the array by name
    if (versionsData.length > 0) {
        versionsData.sort(function (a, b) {
            var nameA = a.name.toUpperCase();
            var nameB = b.name.toUpperCase();

            if (nameA < nameB) {
                return -1;
            }

            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });
    }

    $scope.displayData = versionsData;
};

VersionsViewController.$inject = ["$scope", "$http"];

export default VersionsViewController;
